<template>
	<div class="workflow">
		<!-- 顶部搜索区域 -->
		<div class="search-bar">
			<div class="search-left">
				<span class="page-title">公共基础模型列表</span>
			</div>
		</div>
		<!-- 卡片表格区域 -->
		<div class="content-wrap" style="margin-top:16px">
			<div class="card-grid">
				<div class="project-card" v-for="item in tableData" :key="item.id">
					<!-- 右上角三点下拉菜单 -->
					<el-dropdown trigger="click" @command="(cmd) => handleMenuClick(cmd, item)" class="card-more-wrap">
						<div class="more-btn">
							<i class="el-icon-more" style="transform: rotate(90deg);color: #409EFF;"></i>
						</div>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="AddLatestVersion">添加最新版本</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>

					<div class="card-title-row">
						<span class="title">{{ item.id }}</span>
						<!-- 下线标签 -->
						<el-tag v-if="item.versionRetiring" size="mini" type="warning">即将下线</el-tag>
					</div>
					<p class="card-desc" :title="item.description">{{ item.description || "未描述" }}</p>
					<div class="card-bottom">
						<!-- <span class="type-tag">{{ getDomainLabel(item.capabilities) }}</span> -->
						<div class="author-line">
							<span class="username">callModelId：{{ item.id }}</span>
						</div>
						<div class="author-line">
							<span class="username">厂商：{{ item.owned_by }}</span>
						</div>
					</div>
					<div class="card-icon">
						<img v-if="item.iconUrl" :src="item.iconUrl" class="cover-img" />
						<div v-else class="icon-placeholder"></div>
					</div>
				</div>
			</div>
			<div v-if="tableData.length === 0" class="empty-wrap">暂无数据</div>
		</div>
		<!-- 分页组件 -->
		<el-pagination style="margin-top:16px;text-align:right" background :current-page="pageNum" :page-size="pageSize"
			:total="total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
			@current-change="handlePageChange" />
	</div>
</template>
<script>
	import {
		deepseekModel
	} from '@/js/coze.js'
	export default {
		name: 'deepSeek',
		props: {
			keyId: {
				type: Number,
				default: null,
			}
		},
		data() {
			return {
				// 分页
				pageNum: 1,
				pageSize: 10,
				total: 0,
				tableData: [],
				loading: false
			}
		},
		methods: {
			handleMenuClick(cmd, item) {
				if (cmd === 'AddLatestVersion') {
					this.handleAddLatestVersion(item)
				}
			},
			handleAddLatestVersion(item) {
				item.selectedModelKey=this.keyId
				let bodArrString = JSON.stringify(item)
				localStorage.setItem('deepseek', bodArrString)
				this.$emit("addBot", 4)
			},
			forName(val) {
				console.log('val', val)
				var arr = {
					"qwen": "千问",
					"qwen-domain-model": "阿里巴巴-领域模型",
					"siliconflow": "硅基流动",
					"moonshot": "Kimi",
					"mini-max": "MiniMax",
					"kling": "可灵AI",
					"vidu": "Vidu",
					"pixverse": "PixVerse",
					"vanchin": "快手万擎",
					"xiaomi": "小米MiMo",
					"zhipu-ai": "智谱AI",
					"tripo": "Tripo",
					"wan": "万相",
					"moonshot-ai": "月之暗面",
					"deepseek": "DeepSeek",
					"happyhorse": "阿里巴巴-HappyHorse"
				}

				return arr[val] || val
			},
			// 把modelDomains字符串转中文展示标签
			getDomainLabel(domains) {
				if (!domains) return "未知";
				domains = JSON.parse(domains)
				const map = capabilities()
				return domains.map(d => capabilities(d) || d).join(" / ");
			},
			// pageSize改变
			handleSizeChange(val) {
				this.pageSize = val
				this.pageNum = 1
				this.tolist()
			},
			// 页码点击改变
			handlePageChange(val) {
				this.pageNum = val
				this.tolist()
			},
			async tolist() {
				//provider

				const urlList = [{
						name: "deepseek",
						url: "https://ark-auto-2100466578-cn-beijing-default.tos-cn-beijing.volces.com/model_cardBJ1gRBveyK.png"
					},
					{
						name: "tripo",
						url: "https://ecmb.bdimg.com/tam-ogel/1104934869_1051164529_88_88.png"
					},
					{
						name: "xiaomi",
						url: "https://ecmb.bdimg.com/tam-ogel/128247567_1656370875_88_88.png"
					},
					{
						name: "vanchin",
						url: "https://p4-sl.streamlake.com/kos/nlav11935/streamlake-website/public/img/index/v2/hub-logo.svg"
					},
					{
						name: "pixverse",
						url: "https://gips2.baidu.com/it/u=652099636,3489605172&fm=3081&app=3081&f=PNG?w=460&h=460"
					},
					{
						name: "vidu",
						url: "https://ecmb.bdimg.com/tam-ogel/1302449063_-630342186_88_88.jpg"
					},
					{
						name: "mini-max",
						url: "https://pic.rmb.bdstatic.com/bjh/cms/260227/faac288889635864d94152a743ffdad0_1772126662.7986_8.jpeg"
					},
					{
						name: "kling",
						url: "https://ecmb.bdimg.com/tam-ogel/2129598176_-656804501_88_88.png"
					},
					{
						name: "siliconflow",
						url: "https://ark-auto-2100466578-cn-beijing-default.tos-cn-beijing.volces.com/model_cardBJ1gRBveyK.png"
					}, {
						name: "北京数美万物科技有限公司",
						url: "https://ark-auto-2100466578-cn-beijing-default.tos-cn-beijing.volces.com/model_cardd7CUvDcfXC.png"
					},
					{
						name: "影眸科技（上海）有限公司",
						url: "https://ark-auto-2100466578-cn-beijing-default.tos-cn-beijing.volces.com/model_cardr8hSIFiHdR.png"
					},
					{
						name: "字节跳动",
						url: "https://p11-ark-web-imagex.byteimg.com/tos-cn-i-pbbg71lup3/lm_sth/ljhwZthlaukjlkulzlp/ark/model_icon/vendor/doubao.png~tplv-pbbg71lup3-ark-mini-v1:q75.avis"
					},
					{
						name: "qwen-domain-model",
						url: "https://ark-auto-2100466578-cn-beijing-default.tos-cn-beijing.volces.com/model_cardyZ6Q1VRbgd.jpeg"
					},
					{
						name: "happyhorse",
						url: "https://ark-auto-2100466578-cn-beijing-default.tos-cn-beijing.volces.com/model_cardyZ6Q1VRbgd.jpeg"
					},
					{
						name: "wan",
						url: "https://ark-auto-2100466578-cn-beijing-default.tos-cn-beijing.volces.com/model_cardyZ6Q1VRbgd.jpeg"
					},
					{
						name: "qwen",
						url: "https://ark-auto-2100466578-cn-beijing-default.tos-cn-beijing.volces.com/model_cardyZ6Q1VRbgd.jpeg"
					},
					{
						name: "Mistral AI",
						url: "https://ark-auto-2100466578-cn-beijing-default.tos-cn-beijing.volces.com/model_cardBJ1gRBveyK.png"
					},
					{
						name: "zhipu-ai",
						url: "https://ark-auto-2100466578-cn-beijing-default.tos-cn-beijing.volces.com/model_cardXK2Zy3k6yA.avif"
					},
					{
						name: "moonshot-ai",
						url: "https://ark-auto-2100466578-cn-beijing-default.tos-cn-beijing.volces.com/model_cardXK2Zy3k6yA.avif"
					},
					{
						name: "moonshot",
						url: "https://ark-auto-2100466578-cn-beijing-default.tos-cn-beijing.volces.com/model_cardXK2Zy3k6yA.avif"
					},

				]
				this.loading = true
				try {
					// 调用你写好的分页接口 /xxx/list/simple/page

					let res = await this.API.get(this.API.fileurl.getModelModelList, {
						pageNum: this.pageNum,
						pageSize: this.pageSize
					})
					if (res?.data?.code === 200) {


						let list = res?.data?.data?.records || []
						this.tableData = list.map(v => {
							if (!v.iconUrl) {
								v.iconUrl = urlList?.find(_v => _v.name == v.provider)?.url || null
							}
							return {
								...v
							}
						})

						this.total = res?.data?.data?.total || 0

					}
				} catch (err) {
					console.error('查询模型列表异常', err)
				} finally {
					this.loading = false
				}
			},
			async deepseekModels(){
				try{
					let res=await deepseekModel(this.keyId,"")
					console.log('resres',res)
					this.tableData=res.list||[]
					this.tableData=this.tableData?.map(v=>{
						v.iconUrl="https://ark-auto-2100466578-cn-beijing-default.tos-cn-beijing.volces.com/model_cardBJ1gRBveyK.png"
						return {
							...v
						}
					})
					
					this.total=this.tableData.length
				}catch(e){
					this.tableData=[]
					this.total=0
				}finally{
					
				}
			},
		},
		created() {
			this.deepseekModels()
		}
	}
</script>
<style scoped>
	.workflow {
		padding: 20px;
		background-color: #fff;
	}

	.search-bar {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.page-title {
		font-size: 16px;
		font-weight: 600;
		color: #172033;
	}

	.search-left {
		display: flex;
		align-items: center;
		gap: 12px;
	}

	.card-grid {
		display: grid;
		grid-template-columns: repeat(auto-fill, 300px);
		gap: 16px;
	}

	.project-card {
		overflow: hidden;
		min-height: 160px;
		background: radial-gradient(circle at 94% 12%, rgba(64, 158, 255, .12), transparent 28%),
			linear-gradient(135deg, #ffffff 0%, #f8fbff 56%, #eef7ff 100%);
		border-radius: 16px;
		padding: 14px 14px 14px;
		border: 1px solid rgba(126, 154, 186, .16);
		box-shadow: 0 12px 30px rgba(31, 65, 105, .08);
		transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease;
		position: relative;
	}

	.project-card:hover {
		transform: translateY(-3px);
		background: radial-gradient(circle at 94% 12%, rgba(64, 158, 255, .16), transparent 28%),
			linear-gradient(135deg, #ffffff 0%, #f8fbff 56%, #eef7ff 100%);
		box-shadow: 0 18px 44px rgba(31, 65, 105, .13);
		border-color: rgba(64, 158, 255, .28);
	}

	/* 右上角下拉容器定位 */
	.card-more-wrap {
		position: absolute;
		right: 10px;
		bottom: 10px;
		z-index: 5;
	}

	.more-btn {
		width: 30px;
		height: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 10px;
		cursor: pointer;
		opacity: 0;
		transition: opacity .2s;
		background: rgba(255, 255, 255, .88);
		box-shadow: 0 8px 18px rgba(31, 65, 105, .1);
	}

	/* 卡片hover时展示三点按钮 */
	.project-card:hover .more-btn {
		opacity: 1;
	}

	.more-btn:hover {
		background: #f1f1f1;
	}

	.card-title-row {
		display: flex;
		align-items: center;
		gap: 8px;
		font-size: 16px;
		font-weight: 700;
		margin-bottom: 6px;
		color: #172033;
		padding-right: 70px;
	}

	.card-desc {
		font-size: 13px;
		color: #667085;
		line-height: 1.55;
		margin-bottom: 10px;
		height: 60px;
		display: -webkit-box;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
		overflow: hidden;
		max-width: calc(100% - 70px);
		word-wrap: break-word;
		word-break: break-all;
	}

	.card-bottom {
		display: flex;
		flex-direction: column;
		gap: 6px;
	}

	.type-tag {
		font-size: 11px;
		background: rgba(47, 128, 237, .1);
		color: #2f80ed;
		padding: 3px 7px;
		border-radius: 999px;
		font-weight: 700;
		width: fit-content;
	}

	.author-line {
		font-size: 11px;
		color: #6b7280;
		display: flex;
		gap: 4px;
		align-items: center;
	}

	.username {
		display: inline-block;
		max-width: 100%;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.card-icon {
		position: absolute;
		right: 12px;
		top: 12px;
		width: 60px;
		height: 60px;
		border-radius: 12px;
		overflow: hidden;
		border: 1px solid rgba(255, 255, 255, .8);
		box-shadow: 0 10px 22px rgba(31, 65, 105, .14);
	}

	.cover-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.icon-placeholder {
		width: 100%;
		height: 100%;
		background: #f1f5f9;
	}

	.empty-wrap {
		text-align: center;
		padding: 40px 0;
		color: #999;
	}

	@media (max-width: 1100px) {
		.card-grid {
			grid-template-columns: repeat(2, 1fr);
		}
	}

	@media (max-width: 650px) {
		.card-grid {
			grid-template-columns: 1fr;
		}
	}
</style>